import { render, staticRenderFns } from "./ValuesArea.vue?vue&type=template&id=1a589cbb&scoped=true&"
import script from "./ValuesArea.vue?vue&type=script&lang=js&"
export * from "./ValuesArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a589cbb",
  null
  
)

export default component.exports